export default __webpack_public_path__ + "static/media/luke-chesser.08852dba.jpg";